module.exports = __webpack_public_path__ + "static/media/dk-flag.b005ab1a.svg";